<template>
  <div class="customer-service">
    <Title text="联系客服" />
    <div>
      <div class="contact">
        <h4>联系方式</h4>
        <p>您可拨打电话联系客服，或点击客服QQ，即可在线沟通客服</p>
      </div>
      <div class="service-way">
        <!-- 网页端唤起 -->
        <a
          href="http://wpa.qq.com/msgrd?v=3&amp;uin=137394256&amp;site=qq&amp;menu=yes"
          target="_blank"
          class="qq-wrap"
          @click="toQQClient"
          v-if="flag"
        >
          <div class="icon">
            <img src="../assets/images/main/qq.png" alt />
          </div>
          <span>客服QQ</span>
        </a>
        <!-- 移动端唤起 -->
        <a
          href="mqqwpa://im/chat?chat_type=wpa&uin=137394256&version=1&src_type=web&web_src=oicqzone.com"
          target="_blank"
          class="qq-wrap"
          @click="toQQClient"
          v-if="!flag"
        >
          <div class="icon">
            <img src="../assets/images/main/qq.png" alt />
          </div>
          <span>客服QQ</span>
        </a>
        <div class="phone-wrap">
          <div class="icon">
            <img src="../assets/images/main/phone.png" alt />
          </div>
          <span>客服电话：400-181-1900</span>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="time">
      <h4>服务时间</h4>
      <p>星期一至星期五 9:00-18:00</p>
    </div>
  </div>
</template>

<script>
import Title from "../components/Title";
export default {
  name: "Customer-service",
  data() {
    return {
      flag: true
    };
  },
  components: {
    Title
  },
  methods: {
    //唤起qq
    toQQClient() {
      let userAgentInfo = navigator.userAgent;
      let Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.flag = false;
        } else {
          this.flag = true;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.contact {
  width: 100%;
  height: 260px;
  background: linear-gradient(154deg, #37c1f4 0%, #4761fc 100%),
    linear-gradient(#ad4747, #ad4747);
  padding: 50px 30px;
  box-sizing: border-box;
  color: #fff;
  h4 {
    font-size: 33px;
  }
  p {
    font-size: 28px;
    width: 573px;
    line-height: 40px;
    margin-top: 15px;
  }
}
.service-way {
  width: 690px;
  height: 257px;
  box-shadow: 0px 4px 13px 0px rgba(16, 30, 46, 0.2);
  border-radius: 10px;
  position: absolute;
  top: 300px;
  left: 30px;
  background: #fff;
  font-size: 30px;
  text-align: center;
  .qq-wrap {
    padding: 45px 0;
    border-bottom: 1px solid #f2f2f2;
    display: block;
    color: #666;
  }
  .phone-wrap {
    padding-top: 45px;
  }
  .icon {
    width: 39px;
    height: 39px;
    vertical-align: sub;
    margin-right: 10px;
    display: inline-block;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.line {
  width: 100%;
  height: 20px;
  background: #f5f5f5;
  margin-top: 250px;
}
.time {
  font-size: 28px;
  padding: 50px 30px;
  h4 {
    font-size: 34px;
    margin-bottom: 20px;
  }
}
</style>